import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, Spettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-accredito-spettacolo-backoffice',
  templateUrl: './accredito-spettacolo-backoffice.component.html',
  styleUrl: './accredito-spettacolo-backoffice.component.css'
})
export class AccreditoSpettacoloBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  spettacolo?: Spettacolo;
  evento?: Evento;

  loading: boolean = false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loading = true;
      const id = Number(params['id']);
      this.apiService.getSpettacolo(id).subscribe({
        next: (data) => this.spettacolo = data,
        error: () => this.router.navigate(['/backoffice/spettacoli']),
        complete: () => this.loadEvento(id)
      });
    });
  }

  private loadEvento(id_spettacolo: number) {
    this.apiService.getEventoSpettacolo(id_spettacolo).subscribe({
      next: (data) => {
        this.evento = data;
        this.loading = false;
      },
      error: () => {
        // Area compagnia assente: creala senza utenza, poi ricarica
        this.apiService.ensureEventoSpettacolo(id_spettacolo).subscribe({
          next: () => {
            this.apiService.setSpettacoli();
            this.apiService.getEventoSpettacolo(id_spettacolo).subscribe({
              next: (data) => this.evento = data,
              error: (err) => {
                this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Impossibile aprire area compagnia');
                this.router.navigate(['/backoffice/spettacoli']);
              },
              complete: () => this.loading = false
            });
          },
          error: (err) => {
            this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Impossibile creare area compagnia');
            this.router.navigate(['/backoffice/spettacoli']);
            this.loading = false;
          }
        });
      }
    });
  }

}
